import '../css/main.css'
import './style.css'
import Menu from '../common/menu.js';
import TopBar from "../common/topBar2";
import Create from './create.js'
import DeleteDialog from './delete-dialog.js'
import { useEffect, useState } from 'react';
import BaiscTable from '../tables/default-table.js';
import BasicPagination from '../pagination/basic.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.js';
import { useData } from '../../contexts/DataContext.js';
import DefaultLayout from '../layouts/DefaultLayout.js';
import toast from 'react-hot-toast';
import TopCardSkeleton from '../Skeleton/topCards.js';
import * as XLSX from 'xlsx';
import Loader from '../loaders/loader.jsx';

export default function Clients() {

const [activePage, setActivePage] = useState('gestores');
const [create, setCreate] = useState(false);
const [edit, setEdit] = useState(null);
const [del, setDel] = useState(null);
const [tableSearch,setTableSeach]=useState('');
const {pathname} = useLocation()
const {user,selectedMicrocredit,userInfo,userRole} = useAuth()
const data=useData()
const [loading,setLoading]=useState(false)
let initial_filters={start_date:'',end_date:'',category_id:'',account_id:'',type:'',reference_id:''}
const [filters,setFilters]=useState(initial_filters);
const [printing,setPrinting]=useState(false)
const navigate=useNavigate()

let required_data=['transations']
const [currentPage,setCurrentPage]=useState(1)
const [updateFilters,setUpdateFilters]=useState(null)
const [search,setSearch]=useState('')
const [filterOptions,setFilterOptions]=useState([])
const transation_types=[{id:'out',label:'Saida'},{id:'in',label:'Entrada'}]
const [hideFilters,setHideFilters]=useState(true)

useEffect(()=>{ 
   if(!user || data.updateTable) return
   data.handleLoaded('remove',required_data)
   data._get(required_data,{
     transations:{microcredit_id:selectedMicrocredit,search:search,page:currentPage,...filters,...data.getParamsFromFilters(filterOptions)},
   }) 
 },[user,pathname,search,currentPage,updateFilters])


 useEffect(()=>{
   data.handleLoaded('remove',required_data)
 },[updateFilters])

 useEffect(()=>{
   if(data.updateTable){
        data.setUpdateTable(null)
        data.handleLoaded('remove',required_data)
        setCurrentPage(1)
        data._get(required_data,{transations:{microcredit_id:selectedMicrocredit,search:search,page:1,...filters,...data.getParamsFromFilters(filterOptions)}}) 
   }
},[data.updateTable])

useEffect(()=>{data.setUpdateTable(Math.random())},[filters])


const Print =async (type,_data) => {
     
     let name=(user?.microcredits?.filter(i=>i.id==selectedMicrocredit)[0]?.name || '') +` - transações de caixa ${data.today()} ${data.time()}`
     const mappedData = _data.map(item => ({
          'ID':item.id,
          'Tipo':item.type=="in" ? 'Entrada' :'Saida',
          'Valor': (item.type=="out" ? '-' :'') + data._cn(item.amount),
          'Saldo' :(item.balanceAfterTransaction < 0 ? '-' :'') + data._cn(item.balanceAfterTransaction),
          'Categoria':item.Category.name,
          'Conta':item.Account.name,
          'Descrição':item.description,
          'Referência':item.reference?.name || '-',
          'Criado por':item.microuser?.name || '-',
          'Data de criação':item.created_at.split('T')[0].split('-')?.reverse().join('-'),
     }));
     
     const mappedDataPDF = _data.map(item => ({
          'ID':item.id,
          'Tipo':item.type=="in" ? 'Entrada' :'Saida',
          'Valor': (item.type=="out" ? '-' :'') + data._cn(item.amount),
          'Categoria':item.Category.name,
          'Saldo' :(item.balanceAfterTransaction < 0 ? '-' :'') + data._cn(item.balanceAfterTransaction),
          'Conta':item.Account.name,
          'Referência':item.reference?.name || '-',
          'Data de criação':item.created_at.split('T')[0].split('-')?.reverse().join('-'),
     }));


     if(type=="excel"){
          const workbook = XLSX.utils.book_new();
          const sheetData = XLSX.utils.json_to_sheet(mappedData);
          XLSX.utils.book_append_sheet(workbook, sheetData, 'Sheet1');
          XLSX.writeFile(workbook, `${name}.xlsx`);
     }else{
          data.setPrintData({print:true,data:[mappedDataPDF],names:[name]})
     }

}

const Export =async (type) => {
     
      try{
          setPrinting(true)
          let response=await data.makeRequest({method:'get', url:`api/transations`,params:{
              all:true,microcredit_id:selectedMicrocredit || '',search:search,page:currentPage,...filters,...data.getParamsFromFilters(filterOptions)
          }, error: ``,withToken:true},0);
         Print(type,response.data)
      }catch(e){
          toast.remove()
          let msg="Acorreu um erro, tente novamente"
          if(e.response){
            if(e.response.status==500){
                msg="Erro, inesperado. Contacte seu administrador"
            }
          }else if(e.code=='ERR_NETWORK'){
                msg="Verfique sua internet e tente novamente"
          }
          toast.error(msg)
      }
      setPrinting(false)
}




async function handleItems({status,id}){ 

     data._closeAllPopUps()
     toast.remove()
     toast.loading('A actualizar...') 
     setLoading(true)
    
     try{
        await data.makeRequest({method:'post',url:`microcredit-user/change-status`,withToken:true,data:{
              status,
              id
        }, error: ``},0);
  
        toast.remove()
        toast.success("Actualizado com sucesso")
        data.setUpdateTable(Math.random())
  
     }catch(e){
        toast.remove()
  
        let msg="Acorreu um erro, tente novamente"
  
        setLoading(false)
  
        if(e.response){
          if(e.response.status==409){
            msg="Nome já existe"
          } 
          if(e.response.status==404){
              msg="Item não encontrado"
              setEdit(null)
          }
          if(e.response.status==500){
              msg="Erro, inesperado. Contacte seu administrador"
          }
        }else if(e.code=='ERR_NETWORK'){
              msg="Verfique sua internet e tente novamente"
        }

        toast.error(msg)
  
     }
  }
  

const [reqLoaded,setReqLoaded]=useState(false)

useEffect(()=>{
     setReqLoaded(data.loaded.includes('accounts') && data.loaded.includes('clients_list')  && data.loaded.includes('transations') && data.loaded.includes('account_categories'))
},[data.loaded])

useEffect(()=>{
             if((userRole=="operator" && !userInfo?.permissions?.cash_management_transactions?.includes('read'))){
               navigate('/dashboard')
             }
 },[userInfo])


return (
    <>
     <DefaultLayout>

     <main className="dashboard-container">
     { <Create showD={(create || edit) ? true : false}  create={create} setCreate={setCreate} setEdit={setEdit} edit={edit} del={del}/>}
     { <DeleteDialog showD={del ? true : false} del={del}  setDel={setDel}/>}

     <div className="dashboard">
     <Menu/>
     <div className="main-dashboard">

           <TopBar activePage={'Caixa'}/>
           
           {!data.loaded.includes('transations') && <TopCardSkeleton/>}
           
           <div className={`center`}>

          <div style={{display:!data.loaded.includes('transations') ? 'none':'flex'}} className={`stat_page_2`}>
                             <div className="items">

                                  <div className="box">
                                    <div className="icon blue-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="m216-160-56-56 464-464H360v-80h400v400h-80v-264L216-160Z"/></svg>
                                    </div>
                                    <div className="center-content">
                                       <div className="name">Entradas</div>
                                       <div className="total">{data._cn((data._transations?.totals?.in || 0).toFixed(2))} MT</div>
                                    </div>
                                  </div>


                                   <div className="box">
                                    <div className="icon orange-icon">
                                                       <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M360-200v-80h264L160-744l56-56 464 464v-264h80v400H360Z"/></svg>
                                    </div>
                                    <div className="center-content">
                                       <div className="name">Saidas</div>
                                       <div className="total">{data._transations?.totals?.out ? '-':''} {data._cn((data._transations?.totals?.out || 0).toFixed(2))} MT</div>
                                    </div>
                                 </div>


                                   <div className="box">
                                    <div className="icon green-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" className="opacity-[0.8]"><path d="M200-200v-560 560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v100h-80v-100H200v560h560v-100h80v100q0 33-23.5 56.5T760-120H200Zm320-160q-33 0-56.5-23.5T440-360v-240q0-33 23.5-56.5T520-680h280q33 0 56.5 23.5T880-600v240q0 33-23.5 56.5T800-280H520Zm280-80v-240H520v240h280Zm-160-60q25 0 42.5-17.5T700-480q0-25-17.5-42.5T640-540q-25 0-42.5 17.5T580-480q0 25 17.5 42.5T640-420Z"></path></svg>
                                    </div>
                                    <div className="center-content">
                                       <div className="name">Disponivel</div>
                                       <div className="total">{data._cn((data._transations?.totals?.availableBalance || 0).toFixed(2))} MT</div>
                                    
                                    </div>
                                   
                                 </div>

                             </div>
               </div>
               <div className="center_search">

                    <div className="search_container">
                         <div className="search-div">
                              <input type="text" placeholder="Pesquisar cliente..." value={search} onChange={(e)=>{
                                   setSearch(e.target.value)
                                   data.setUpdateTable(Math.random())
                                   
                              }}/>
                                   <div className="search-btn">
                                   <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                              </div>
                         </div>
                    </div>

                    <div className="flex items-center">
                         <div onClick={()=>
                         data.setUpdateTable(Math.random())
                         } className="mr-2 cursor-pointer hover:opacity-65">
                              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"/></svg>
                         </div>
                         {(userRole!="operator" || userInfo?.permissions?.cash_management_transactions?.includes('create')) && <div className="btn-add-item" onClick={()=>setCreate(true)}>
                                   <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path fill="#fff" d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"></path></svg>
                                   <span>Adicionar</span>
                         </div>}
                    </div>
               </div>



               <div className={`extra-filters ${hideFilters ? '_hide':''}`}>
                    <label onClick={()=>setHideFilters(!hideFilters)} className="underline sm:hidden text-[15px]  text-custom_blue-400 absolute top-4 cursor-pointer">{hideFilters ? 'Mostrar filtros':'Esconder filtros'}</label>

                    <div className="input-container">

                         <div className="inputs">
                              <span>Data de inicio</span>
                              <input type="date" value={filters.start_date} onChange={(e)=>setFilters({...filters,start_date:e.target.value})} />
                         </div>

                         <div className="inputs">
                              <span>Data de fim</span>
                              <input type="date" value={filters.end_date} onChange={(e)=>setFilters({...filters,end_date:e.target.value})} />
                         </div>


                         <div className="inputs">
                              <span>Tipo de transação</span>
                              <select  value={filters.type} onChange={e=>setFilters({...filters, type:e.target.value})}>
                                   <option selected value="">Selecionar Transação</option>
                                   {transation_types.map(i=>(
                                        <option key={i.id} selected={filters.type === i.id} value={i.id}>{i.label}</option>
                                   ))}
                              </select>
                         </div>

                         <div className="inputs">
                              <span>Categoria</span>
                              <select value={filters.category_id} onChange={e=>setFilters({...filters, category_id:e.target.value})}>
                                   <option  selected value="">Selecionar Categoria</option>
                                   {data._account_categories.map(i=>(
                                        <option key={i.id} selected={filters.category_id === i.id} value={i.id}>{i.name}</option>
                                   ))}
                              </select>
                         </div>

                         <div className="inputs">
                              <span>Conta</span>
                              <select value={filters.account_id} onChange={e=>setFilters({...filters, account_id:e.target.value})}>
                                        <option selected value="">Selecionar Conta</option>
                                        {data._accounts.map(i=>(
                                             <option key={i.id} selected={filters.account_id === i.id} value={i.id}>{i.name} {i.description ? `(${i.description})`:''}</option>
                                        ))}
                              </select>
                         </div>

                         <div className="inputs">
                              <span>Cliente</span>
                              <select value={filters.reference_id} onChange={e=>setFilters({...filters, reference_id:e.target.value})}>
                                        <option selected value="">Selecionar cliente</option>
                                        {data._clients_list.sort((a, b) => (a.deleted_at === null ? -1 : 1) - (b.deleted_at === null ? -1 : 1)).map(i=>(
                                             <option key={i.id} selected={filters.reference_id === i.id} value={i.id}>{i.name} {i.deleted_at ? '(Arquivado)':''}</option>
                                        ))}
                              </select>
                         </div>
                         
                         
                    </div>

                    <div className="options">
                    <span onClick={()=>setFilters(initial_filters)}>
                         <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path fill="#fff" d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z"/></svg> </span>
                    </div>

               </div>


               <div className="dasboard-item-list-container">
               <div className="top-section">
                         <div className="left-side">
                                   <div className="show">
                                             <span>Resultados:</span>
                                             <label>{data._transations?.total}</label>
                                   </div>
                              
                         </div>
                        
                         <div className="right-side">
                                        {printing ? <>
                                                  <Loader/>
                                        </> : <>
                                             <span onClick={()=>{
                                                  Export('pdf')
                                             }} className="export export-excel page" style={{background:'rgb(74, 205, 53)'}}>
                                                  <svg width="21" viewBox="0 0 24 24" style={{fill:'#fff'}} xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M9 12.5H10V10.5H11C11.2833 10.5 11.5208 10.4042 11.7125 10.2125C11.9042 10.0208 12 9.78333 12 9.5V8.5C12 8.21667 11.9042 7.97917 11.7125 7.7875C11.5208 7.59583 11.2833 7.5 11 7.5H9V12.5ZM10 9.5V8.5H11V9.5H10ZM13 12.5H15C15.2833 12.5 15.5208 12.4042 15.7125 12.2125C15.9042 12.0208 16 11.7833 16 11.5V8.5C16 8.21667 15.9042 7.97917 15.7125 7.7875C15.5208 7.59583 15.2833 7.5 15 7.5H13V12.5ZM14 11.5V8.5H15V11.5H14ZM17 12.5H18V10.5H19V9.5H18V8.5H19V7.5H17V12.5ZM8 18C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H8ZM8 16H20V4H8V16ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V6H4V20H18V22H4Z" />
                                                  </svg>
                                             </span>
                                             
                                             <span onClick={()=>{
                                                  Export('excel')
                                             }} className="export export-excel page" style={{background:'rgb(74, 205, 53)'}}>
                                             <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24"><path fill="#fff" d="M18 22a2 2 0 0 0 2-2v-5l-5 4v-3H8v-2h7v-3l5 4V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12zM13 4l5 5h-5V4z"></path></svg>
                                             </span>
                                             
                                        </>}
                         </div>


                    </div>

               <BaiscTable canAdd={user?.role=="admin"} addRes={()=>{
                     setCreate(true)
                }}  loaded={data._loaded.includes('transations')} header={[
                    'ID',
                    'Data',
                    'Referência',
                    'Descrição',
                    'Tipo de Transação',
                    'Montante',
                    'Saldo',
                    'Conta',
                    'Categoria',
                    'Criado por',
                    'Responsável pela transação'
                    ]
               }

               body={(data._transations?.data || []).map((i,_i)=>(
                    
                         <BaiscTable.Tr>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{i.id}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{data._c_date(i.created_at).split('T')[0]?.split('-')?.reverse()?.join('/')} {data._c_date(i.created_at).split('T')[1].slice(0,5)}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{i.reference?.name || '-'}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{i.description}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>
                            <button style={{ backgroundColor:i.type=='in' ? '#668cde':  '#eac059',border:0}} type="button"  class={`text-gray-900 cursor-default  focus:outline-none  font-medium rounded-[0.3rem] text-sm px-2 py-1 text-center inline-flex items-center`}>
                                 {i.type=='in' ? 'Entrada':  'Saida'}
                            </button>
                         </BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{data._cn(i.amount.toFixed(2))}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{data._cn(i.balanceAfterTransaction)}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{i.Account.name}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{i.Category.name}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{i.microuser.name}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>setEdit(i)}>{i.transition_performed_by?.name || '-'}</BaiscTable.Td>
                         <BaiscTable.AdvancedActions data={data} w={200} id={i.id} items={[
                              {name:'Eliminar',onClick:()=>{
                                   setTimeout(()=>{
                                         data.setItemsToDelete({...data.itemsToDelete,url:'api/transations/delete',items:[i.id]})
                                         data._showPopUp('delete')
                                   },100)
                              },hide:i.contract_id  || (userRole!="manager" && !userInfo?.permissions?.cash_management_transactions?.includes('delete')),icon:(<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#5f6368"><path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"></path></svg>)},
                              {name:'Desactivar',hide:i.status=="inactive" || user?.role!="admin",onClick:()=>{handleItems({status:'inactive',id:i.id})},icon:(<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>)},
                              {name:'Activar',hide:i.status=="active"  || user?.role!="admin",onClick:()=>{handleItems({status:'active',id:i.id})},icon:(<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>)},
                          ]}/>
                    </BaiscTable.Tr>
                    ))}
          />

               <BasicPagination show={data._loaded.includes('transations')} from={'transations'} setCurrentPage={setCurrentPage} total={data._transations?.total}  current={data._transations?.page} last={data._transations?.totalPages}/>


               </div>

          </div>

          
     </div>
     </div>
     </main>

     </DefaultLayout>
    </>
  );
}
